module.exports = __webpack_public_path__ + "img/award.c7c1a1f1.svg";